import {Criteria} from './criteria';
import {OrderByField} from './orderByField';
import {Criterion} from './criterion';

export class Query {
  public static readonly IS_NULL = 'is null';
  public static readonly IS_NOT_NULL = 'is not null';
  public static readonly EQUAL = '=';
  public static readonly NOT_EQUAL = '<>';
  public static readonly GREATER_THAN = '>';
  public static readonly GREATER_THAN_OR_EQUAL = '>=';
  public static readonly LESS_THAN = '<';
  public static readonly LESS_THAN_OR_EQUAL = '<=';
  public static readonly IN = 'in';
  public static readonly NOT_IN = 'not in';
  public static readonly LIKE = 'like';
  public static readonly NOT_LIKE = 'not like';
  public static readonly BETWEEN = 'between';
  public static readonly NOT_BETWEEN = 'not between';
  public static readonly CUSTOM = 'custom';

  public static readonly AND = 'and';
  public static readonly OR = 'or';

  public static readonly ASC = 'asc';
  public static readonly DESC = 'desc';

  alias: string;
  offset: number;
  limit: number;
  distinct: boolean;

  private criterias: Criteria[];
  private orderBy: OrderByField[];
  parameters: { [key: string]: any };

  constructor() {
    this.parameters = {};
    this.offset = 0;
    this.limit = 0;
    this.distinct = false;
    this.criterias = [];
    this.orderBy = [];
  }

  clear() {
    this.offset = 0;
    this.limit = 0;
    this.criterias.length = 0;
    this.orderBy.length = 0;
  }

  clearWhere() {
    this.criterias.length = 0;
  }

  clearOrder() {
    this.orderBy.length = 0;
  }

  add(crit: Criteria): Query {
    this.criterias.push(crit);
    return this;
  }

  and(): Criteria {
    const crit = new Criteria(Query.AND);
    this.criterias.push(crit);
    return crit;
  }

  or(): Criteria {
    const crit = new Criteria(Query.OR);
    this.criterias.push(crit);
    return crit;
  }

  addOrderBy(orderByField: OrderByField): Query {
    this.orderBy.push(orderByField);
    return this;
  }

  addOrderByField(tableAlias: string, fieldName: string, sufix: string): Query {
    this.orderBy.push(new OrderByField(tableAlias, fieldName, sufix));
    return this;
  }

  findCriterion(critName: String): Criterion {
    for (const crit of this.criterias) {
      const criterion = crit.findCriterion(critName);
      if (criterion != null) {
        return criterion;
      }
    }

    return null;
  }

  isOrderByEmpty(): boolean {
    return this.orderBy.length === 0;
  }

  public getCriterias(): Criteria[] {
    return this.criterias;
  }
}
